module.exports = __webpack_public_path__ + "static/img/train_weight_blue.bce9d84.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/train_weight_blue.png
// module id = 8N+G
// module chunks = 1